import { inject, Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of } from "rxjs";
import { TranslationHttpService } from "./translation.http";
import { CreateTranslationResponse, LanguageCode, PreferredLanguague, TransalationContentPayload, TranslateSignal, TranslationContentResponse, TranslationPayload, TranslationSetResponse, TranslationView } from "./translation.type";

@Injectable({
    providedIn: 'root'
})
export class TranslationTextService {
    readonly #translationService = inject(TranslationHttpService);

    readonly #translationSetPayload$ = new BehaviorSubject<Record<string, TranslationView> | null>(null);

    readonly #translateSignal = new BehaviorSubject<TranslateSignal | null>(null);

    readonly #originalTextSignal$ = new BehaviorSubject<TranslationView | null>(null);

    readonly #preferredLanguage$ = new BehaviorSubject<PreferredLanguague | null>(null);

    readonly translationStorage = new Map<string, TranslationView[]>();

    readonly currentTranlationPayload = new Map<string, TranslationView>();

    readonly requestList: { originalText: string, controlName: string }[] = [];

    get translationSetPayload$(): Observable<Record<string, TranslationView> | null> {
        return this.#translationSetPayload$.asObservable();
    }

    get translateSignal$(): Observable<TranslateSignal | null> {
        return this.#translateSignal.asObservable();
    }

    get originalTextSignal$(): Observable<TranslationView | null> {
        return this.#originalTextSignal$.asObservable()
    }

    get preferredLanguage$(): Observable<PreferredLanguague | null> {
        return this.#preferredLanguage$.asObservable()
    }

    updateTranslationSetPayload(value: Record<string, TranslationView> | null): void {
        this.#translationSetPayload$.next(value)
    }

    updateToggleTranslation(value: TranslateSignal | null): void {
        this.#translateSignal.next(value)
    }

    updateOriginalTextSignal(value: TranslationView | null): void {
        this.#originalTextSignal$.next(value);
    }

    updatePreferredLanguage(value: PreferredLanguague | null): void {
        this.#preferredLanguage$.next(value);
    }

    translationText(translateContent: TransalationContentPayload): Observable<TranslationContentResponse> {
        return this.#translationService.translationText(translateContent);
    }

    getTranslation(id: string): Observable<TranslationSetResponse | null> {
        if (!id) {
            return of(null);
        }
        
        return this.#translationService.getTranslation(id);
    }

    createTranslation(payload: TranslationPayload): Observable<CreateTranslationResponse> {
        return this.#translationService.createTranslation(payload);
    }
}